<script>
    import { userProfile, signOut } from "../store/auth.js";

    function goTo(routeName) {

    }

</script>
{#if $userProfile}
<div class="user-profile">
    <div class="dropdown">
        <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="user-profile-drowdown">
            <span class="username">{$userProfile.name}</span>
            <i class="fa fa-caret-down  text-secondary"></i>
        </div>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <button on:click="{signOut}" class="dropdown-item btn-sm" type="button">Sign Out</button>
        </div>
    </div>
</div>
{/if}